import constantiX from "../constantiX";

export const languageSupported = [
  {
    language: "Italiano",
    icon: "flag-it",
    key: "it",
    default: true,
  },
  {
    language: "Inglese",
    icon: "flag-uk",
    key: "en",
    default: true,
  },
  {
    language: "Francese",
    icon: "flag-fr",
    key: "fr",
    default: false,
  },
  {
    language: "Spagnolo",
    icon: "flag-es",
    key: "es",
    default: false,
  },
];

export const getCommonParam = () => {
  const apiUrl = constantiX.UrlCallApi;
  const token = sessionStorage.getItem("ICEtoken");
  const user = JSON.parse(sessionStorage.getItem("utente"));
  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const companyId = user?.aziendaid;

  const apiCommonParam = { apiUrl, user, companyId, axiosConfig };
  return apiCommonParam;
};
